export default __webpack_public_path__ + "static/media/562.b24ae039.png";